import { Box, BoxProps, Card, CardProps } from '@mui/material';
import { APPBAR_HEIGHT } from 'layouts/dashboard/DashboardNavbar';
import { forwardRef, ReactNode } from 'react';

type StickyContainerProps = BoxProps & {
  sticky?: boolean;
  paddingBottom?: string;
  children: ReactNode;
};

const StickyContainer = forwardRef<HTMLDivElement, StickyContainerProps>(
  ({ sticky = true, paddingBottom = '0', sx, children, ...other }, ref) => {
    return (
      <Box
        ref={ref}
        sx={{
          position: sticky ? 'sticky' : 'inherit',
          zIndex: 100,
          width: '100%',
          display: 'flex',
          top: `calc(${APPBAR_HEIGHT}px)`,
          pointerEvents: 'none',
          justifyContent: 'flex-end',
          alignItems: 'center',
          height: '6rem',
          flex: 1,
          maxWidth: '100%',
          pb: paddingBottom,
          ...sx
        }}
        {...other}
      >
        {children}
      </Box>
    );
  }
);

type HeaderCardProps = CardProps & {
  children: ReactNode;
};

const HeaderCard = ({ children, sx, ...other }: HeaderCardProps) => {
  return (
    <Card
      sx={{
        paddingInline: '1rem',
        pointerEvents: 'auto',
        '& > * .MuiButtonBase-root': {
          minWidth: 'max-content'
        },
        '& > *': {
          minWidth: 'max-content'
        },
        overflowX: 'auto',
        height: 'max-content',
        overflowY: 'visible',
        ...sx
      }}
      {...other}
    >
      {children}
    </Card>
  );
};

export type PageHeaderProps = {
  children: ReactNode;
  sticky?: boolean;
  paddingBottom?: string;
};

const PageHeader = forwardRef<HTMLDivElement, PageHeaderProps>(
  ({ children, sticky = true, paddingBottom = '0' }, ref) => {
    return (
      <StickyContainer ref={ref} sticky={sticky} paddingBottom={paddingBottom}>
        <HeaderCard sx={{ overflowX: 'auto' }}>{children}</HeaderCard>
      </StickyContainer>
    );
  }
);

export default PageHeader;
